import {
  Country,
  GetHrBusinessPartnersByCountryQuery,
  GetHrBusinessPartnersByCountryQueryVariables,
  EmployeeNameSearchInfo,
  NameSearchForHrbpSelectQuery,
  NameSearchForHrbpSelectQueryVariables,
} from '../../types'
import { QueryResult, useQuery } from '@apollo/client'
import { ACTIVE_HRBPS_BY_COUNTRY, POSSIBLE_COMPANIES_FOR_CREATE_NEW_HRBP, NAME_SEARCH_FOR_HRBP_SELECT } from './HRBPQueries'
import {
  GetPossibleCompaniesForCreateNewHrBusinessPartnerQuery,
  GetPossibleCompaniesForCreateNewHrBusinessPartnerQueryVariables,
} from '../../../../integration-tests/common/types'
import { client } from '../..'

export const useActiveHrBusinessPartnersByCountry = (
  country: Country,
): QueryResult<GetHrBusinessPartnersByCountryQuery, GetHrBusinessPartnersByCountryQueryVariables> => {
  return useQuery<GetHrBusinessPartnersByCountryQuery, GetHrBusinessPartnersByCountryQueryVariables>(ACTIVE_HRBPS_BY_COUNTRY, {
    variables: { country },
    fetchPolicy: 'network-only',
  })
}

export const usePossibleCompaniesForCreateNewHRBusinessPartner = (): QueryResult<
  GetPossibleCompaniesForCreateNewHrBusinessPartnerQuery,
  GetPossibleCompaniesForCreateNewHrBusinessPartnerQueryVariables
> => {
  return useQuery<GetPossibleCompaniesForCreateNewHrBusinessPartnerQuery, GetPossibleCompaniesForCreateNewHrBusinessPartnerQueryVariables>(
    POSSIBLE_COMPANIES_FOR_CREATE_NEW_HRBP,
    {
      fetchPolicy: 'network-only',
    },
  )
}

export const getPossibleHRBPsByNameSearch = async (
  callback: (any: EmployeeNameSearchInfo[]) => void,
  country: Country,
  searchString: string,
  limit: number,
): Promise<void> => {
  const result = await client.query<NameSearchForHrbpSelectQuery, NameSearchForHrbpSelectQueryVariables>({
    query: NAME_SEARCH_FOR_HRBP_SELECT,
    variables: {
      country,
      searchString: searchString,
      limit: limit,
    },
  })

  const { errors, data, loading } = result
  if (!errors && !loading && data && data.nameSearchForHRBPSelect) callback(data.nameSearchForHRBPSelect)
}
